// services/reqSolicitudes.js
import axios from "../../../config/axiosConfig";

// Requerimiento
export const getRequerimiento = (cod) =>
  axios.get(`/api/req-solicitudes/${cod}`);

export const updateRequerimiento = (cod, body) =>
  axios.put(`/api/req-solicitudes/${cod}`, body);

export const updateEstado = (cod, body) =>
  axios.put(`/api/req-solicitudes/${cod}/estado`, body);

export const getHistory = (cod) =>
  axios.get(`/api/req-solicitudes/${cod}/history`);

// Coordinación
export const updateCoordinacion = (coordId, body) =>
  axios.put(`/api/req-solicitudes/coordinaciones/${coordId}`, body);

// Adición → Programación
export const getCatalogoModems = (cod, params) =>
  axios.get(`/api/req-solicitudes/${cod}/catalogo-modems`, { params });

// Modems ya vendidos a este mismo cliente, pendientes de reactivar.
export const getCatalogoModemsVendidos = (cod, params) =>
  axios.get(`/api/req-solicitudes/${cod}/catalogo-modems-vendidos`, { params });

export const getAsignacionesModems = (cod) =>
  axios.get(`/api/req-solicitudes/${cod}/asignaciones/modems`);

export const assignChip = (cod, modemId, body) =>
  axios.post(`/api/req-solicitudes/${cod}/modems/${modemId}/assign-chip`, body);

// Auxiliares
export const getUsuariosTrs = (params) =>
  axios.get("/api/usuarios-trs", { params });

export const getClienteServicio = (id) =>
  axios.get(`/api/cliente-servicio/${id}`);

export const getTercializados = (base, buscar = "", limit = 20) =>
  axios.get("/api/req-solicitudes/tercializados", {
    params: { base: String(base), buscar, limit },
  });

export const getCatalogoClientesServicio = (buscar = "", page = 1, pageSize = 30, cod_servicio = 2) =>
  axios.get("/api/req-solicitudes/catalogo-clientes-servicio", {
    params: { buscar, page, pageSize, cod_servicio },
  });

export const unassignChip = (cod, modemId, body) =>
  axios.post(`/api/req-solicitudes/${cod}/modems/${modemId}/unassign-chip`, body);
//para trabajo de campo
export const getAdicionAsignados = (cod) =>
  axios.get(`/api/req-adicion/${cod}/asignados`);

export const getAdicionPlacasModemsVinculacion = (cod, params = {}) =>
  axios.get(`/api/req-adicion/${encodeURIComponent(cod)}/vinculacion/placas-modems`, { params });

export const postVincularClienteAdicional = (cod, num_sim, body = {}) =>
  axios.post(
    `/api/req-adicion/${encodeURIComponent(cod)}/modems/${encodeURIComponent(num_sim)}/vincular-cliente`,
    body
  );

export const postVincularPlacaClienteAdicional = (cod, placa, body = {}) =>
  axios.post(
    `/api/req-adicion/${encodeURIComponent(cod)}/placas/${encodeURIComponent(placa)}/vincular-cliente`,
    body
  );

export const getNotaPdf = (cod) =>
  axios.get(`/api/req-adicion/${cod}/nota.pdf`, { responseType: "blob" });

export const getNotaPdfDevolucion = (cod) =>
  axios.get(`/api/req-devolucion/${cod}/nota.pdf`, { responseType: "blob" });

const modemImagenUrl = (cod, num_sim) =>
  `/api/req-solicitudes/${encodeURIComponent(cod)}/modems/${encodeURIComponent(num_sim)}/imagen`;

const modemImagenForm = (imagen) => {
  const form = new FormData();
  if (imagen) form.append("imagen", imagen);
  return form;
};

const multipartConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

export const getModemImagen = (cod, num_sim) =>
  axios.get(modemImagenUrl(cod, num_sim));

export const postModemImagen = (cod, num_sim, imagen) =>
  axios.post(modemImagenUrl(cod, num_sim), modemImagenForm(imagen), multipartConfig);

export const putModemImagen = (cod, num_sim, imagen) =>
  axios.put(modemImagenUrl(cod, num_sim), modemImagenForm(imagen), multipartConfig);

export const deleteModemImagen = (cod, num_sim) =>
  axios.delete(modemImagenUrl(cod, num_sim));

export const updateModemDatos = (cod, num_sim, body) =>
  axios.put(
    `/api/req-solicitudes/${encodeURIComponent(cod)}/modems/${encodeURIComponent(num_sim)}/datos`,
    body
  );

export const postAsignarPlaca = async (cod, num_sim, payload) => {
  const form = new FormData();
  form.append("placa", payload.placa);
  form.append("alias", payload.alias || "");
  form.append("transportista", payload.transportista || "");
  form.append("grupo", payload.grupo || "");
  form.append("sociedad", payload.sociedad || "");
  form.append("observacion", payload.observacion || "");
  if (payload.imageFile) form.append("imagen", payload.imageFile);

  return axios.post(`/api/req-adicion/${cod}/modems/${num_sim}/asignar-placa`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  
};

export const getPlacasPorServicioCliente = (cod_servicio_cliente) =>
  axios.get(`/api/equipos-modem/placas/${encodeURIComponent(cod_servicio_cliente)}`);

export const getCatalogoPlacasVehiculos = (cod_servicio_cliente, buscar = "", limit = 20) =>
  axios.get("/api/req-solicitudes/catalogo-placas-vehiculos", {
    params: { cod_servicio_cliente, buscar, limit },
  });

export const getPlacasPorCliente = (cod_servicio_cliente) =>
  axios.get(`/api/equipos-modem/placas-por-cliente/${encodeURIComponent(cod_servicio_cliente)}`);

export const getReqSolicitudes = (params = {}) =>
  axios.get("/api/req-solicitudes", { params });

export const exportarReqSolicitudesExcel = (params = {}) =>
  axios.get("/api/req-solicitudes/reporte/exportar-excel", { params, responseType: "blob" });

export const exportarReqSolicitudesPdf = (params = {}) =>
  axios.get("/api/req-solicitudes/reporte/exportar-pdf", { params, responseType: "blob" });

export const getModemsEsperaPlataforma = (params = {}) =>
  axios.get("/api/req-solicitudes/modems/espera-plataforma", { params });

export const procesarModemEsperaPlataforma = (id_historial, body = {}) =>
  axios.put(`/api/req-solicitudes/modems/espera-plataforma/${encodeURIComponent(id_historial)}`, body);
